import { validateTidalLicense } from "../../base/index.js";
import { WHITE_SPACES } from "./utils/constants.js";
function trimRight(source, chars = WHITE_SPACES) {
  const charLen = chars.length;
  let end = source.length - 1;
  let found = true;
  let i;
  let c;
  while (found && end >= 0) {
    found = false;
    i = -1;
    c = source.charAt(end);
    while (++i < charLen) {
      if (c === chars[i]) {
        found = true;
        end--;
        break;
      }
    }
  }
  return end >= 0 ? source.substring(0, end + 1) : "";
}
validateTidalLicense();
export {
  trimRight
};
//# sourceMappingURL=trimRight.js.map
